"use client";
import { Theme } from "@/enums";
import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from "react";
import { useTheme } from "./Theme.context";
import {
  TCompanyRegistrationGeorgia,
  TPrivateRegistrationGeorgia,
} from "../types/registrationGe.types";

import { TRegistrationUz } from "../types/registrationUz.types";

import { TRegistrationUkraine } from "../types/registrationUk.types";

import { registrationStepsDataGeorgia } from "../configs/registrationSteps/Ge/registrationStepsGe";
import { registrationStepsDataUz } from "../configs/registrationSteps/Uz/registrationStepsUz";
import {
  AccountType,
  RegistrationCompanyStepGe,
  RegistrationStepGe,
  RegistrationStepUk,
  RegistrationStepUz,
} from "@/enums/registrationSteps.enum";
import { registrationStepsDataUk } from "../configs/registrationSteps/Uk/RegistrationStepsUk";

interface RegistrationContextType {
  activeStepGeorgia: RegistrationStepGe | RegistrationCompanyStepGe;
  setActiveStepGeorgia?: Dispatch<
    SetStateAction<RegistrationStepGe | RegistrationCompanyStepGe>
  >;
  activeStepUzbekistan: RegistrationStepUz;
  setActiveStepUzbekistan?: Dispatch<SetStateAction<RegistrationStepUz>>;
  activeStepUkraine: RegistrationStepUk;
  setActiveStepUkraine?: Dispatch<SetStateAction<RegistrationStepUk>>;
  accountType: AccountType;
  setAccountType?: Dispatch<SetStateAction<AccountType>>;
  registrationStepsGeorgia:
    | TPrivateRegistrationGeorgia
    | TCompanyRegistrationGeorgia;
  registrationStepsUzbekistan: TRegistrationUz;
  registrationStepsUkraine: TRegistrationUkraine;
}

const RegistrationContext = createContext<RegistrationContextType>(null);

export function useRegistration() {
  return useContext(RegistrationContext);
}

export function RegistrationProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const theme = useTheme();

  const [accountType, setAccountType] = useState<AccountType>(
    AccountType.private,
  );

  const [activeStepGeorgia, setActiveStepGeorgia] =
    useState<RegistrationStepGe>(RegistrationStepGe.ACCOUNTTYPE);

  const [activeStepUzbekistan, setActiveStepUzbekistan] =
    useState<RegistrationStepUz>(RegistrationStepUz.CONTACTINFO);

  const [activeStepUkraine, setActiveStepUkraine] =
    useState<RegistrationStepUk>(RegistrationStepUk.CONTACTINFO);

  const registrationStepsGeorgia = useMemo(() => {
    if (theme) {
      if (theme === Theme.GEORGIA) {
        return registrationStepsDataGeorgia[accountType];
      }
    }
  }, [theme, accountType]);

  const registrationStepsUzbekistan = useMemo(() => {
    if (theme) {
      if (theme === Theme.UZ) {
        return registrationStepsDataUz;
      }
    }
  }, [theme]);

  const registrationStepsUkraine = useMemo(() => {
    if (theme) {
      if (theme === Theme.UK) {
        return registrationStepsDataUk;
      }
    }
  }, [theme]);

  return (
    <RegistrationContext.Provider
      value={{
        activeStepGeorgia,
        setActiveStepGeorgia,
        activeStepUzbekistan,
        setActiveStepUzbekistan,
        activeStepUkraine,
        setActiveStepUkraine,
        accountType,
        setAccountType,
        registrationStepsGeorgia,
        registrationStepsUzbekistan,
        registrationStepsUkraine,
      }}
    >
      {children}
    </RegistrationContext.Provider>
  );
}
